/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { TemplateSection } from './TemplateSection';
import {
    TemplateSectionFromJSON,
    TemplateSectionFromJSONTyped,
    TemplateSectionToJSON,
    TemplateSectionToJSONTyped,
} from './TemplateSection';

/**
 * 
 * @export
 * @interface SaveDraftRequest
 */
export interface SaveDraftRequest {
    /**
     * 
     */
    sections?: Array<TemplateSection>;
    /**
     * 
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the SaveDraftRequest interface.
 */
export function instanceOfSaveDraftRequest(value: object): value is SaveDraftRequest {
    return true;
}

export function SaveDraftRequestFromJSON(json: any): SaveDraftRequest {
    return SaveDraftRequestFromJSONTyped(json, false);
}

export function SaveDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(TemplateSectionFromJSON)),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function SaveDraftRequestToJSON(json: any): SaveDraftRequest {
    return SaveDraftRequestToJSONTyped(json, false);
}

export function SaveDraftRequestToJSONTyped(value?: SaveDraftRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(TemplateSectionToJSON)),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

